import React, { memo } from 'react';

const Swimlane = memo(({
  swimlane,
  index,
  totalLanes,
  canvasHeight,
  isSelected,
  onSelect,
  onDoubleClick,
  onResize,
  onDragStart
}) => {
  const { id, label, color = '#f3f4f6', width = 250 } = swimlane;

  // Calculate x position based on previous lanes
  const x = swimlane.x || 0;

  const handleClick = (e) => {
    e.stopPropagation();
    onSelect?.(id);
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    onDoubleClick?.(id);
  };

  const handleResizeMouseDown = (e) => {
    e.stopPropagation();
    onResize?.(e, id);
  };

  const handleHeaderMouseDown = (e) => {
    if (e.button !== 0) return;
    e.stopPropagation();
    onDragStart?.(e, id, index);
  };

  // Determine text color based on background
  const isLightColor = (hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 160;
  };

  const headerTextColor = isLightColor(color) ? '#374151' : '#ffffff';

  return (
    <g className="swimlane" transform={`translate(${x}, 0)`}>
      {/* Background */}
      <rect
        x={0}
        y={0}
        width={width}
        height={canvasHeight}
        fill={color}
        fillOpacity={0.08}
        stroke={isSelected ? '#3b82f6' : '#e5e7eb'}
        strokeWidth={isSelected ? 2 : 1}
        onClick={handleClick}
      />

      {/* Header */}
      <g
        style={{ cursor: 'grab' }}
        onMouseDown={handleHeaderMouseDown}
        onDoubleClick={handleDoubleClick}
      >
        <rect
          x={0}
          y={0}
          width={width}
          height={40}
          fill={color}
          stroke={isSelected ? '#3b82f6' : '#d1d5db'}
          strokeWidth={isSelected ? 2 : 1}
        />
        <text
          x={width / 2}
          y={25}
          textAnchor="middle"
          fontSize="14"
          fontWeight="600"
          fill={headerTextColor}
          pointerEvents="none"
        >
          {label}
        </text>
      </g>

      {/* Resize handle on right edge */}
      <rect
        x={width - 4}
        y={0}
        width={8}
        height={canvasHeight}
        fill="transparent"
        style={{ cursor: 'col-resize' }}
        onMouseDown={handleResizeMouseDown}
      />

      {/* Visual resize indicator */}
      <line
        x1={width}
        y1={0}
        x2={width}
        y2={canvasHeight}
        stroke={isSelected ? '#3b82f6' : '#e5e7eb'}
        strokeWidth={1}
        strokeDasharray={isSelected ? 'none' : '4,4'}
        pointerEvents="none"
      />

      {/* Selection indicator */}
      {isSelected && (
        <rect
          x={-2}
          y={-2}
          width={width + 4}
          height={44}
          fill="none"
          stroke="#3b82f6"
          strokeWidth={2}
          rx={4}
          pointerEvents="none"
        />
      )}
    </g>
  );
});

Swimlane.displayName = 'Swimlane';

export default Swimlane;
